module.exports = __webpack_public_path__ + "img/carrot_collapse.4a6f7d58.svg";